import React from "react";
import BillProviderCardSkeleton from "./BillProviderCardSkeleton";
import BillsSearchSkeleton from "./BillsSearchSkeleton";

export default function BillsPageSkeleton({
  resultsLabel = "Loading providers...",
  sectionTitle = "All Bill Providers",
  viewMode = "grid",
}) {
  return (
    <section className="bills-page__providers" aria-hidden="true">
      <div className="bills-page__toolbar row g-3 align-items-center">
        <div className="col-12 col-lg">
          <BillsSearchSkeleton />
        </div>
        <div className="col-12 col-lg-auto">
          <div className="bills-page__toggle bills-page__toggle--skeleton">
            <div className="skeleton-toggle-button" />
            <div className="skeleton-toggle-button is-active" />
          </div>
        </div>
      </div>

      <div className="bills-page__section-header">
        <h2>{sectionTitle}</h2>
        <span className="bills-page__results">{resultsLabel}</span>
      </div>

      <div className={`row g-3 bills-page__providers-grid is-${viewMode}`}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className={
              viewMode === "grid" ? "col-12 col-md-6 col-xl-4" : "col-12"
            }
          >
            <BillProviderCardSkeleton viewMode={viewMode} />
          </div>
        ))}
      </div>
    </section>
  );
}
